<template>
    <div class="logo-box ">
        <div class="logo-group flex align-center">
            <van-icon v-show="!showBack && show" @click="back()" name="arrow-left" class="back" />
            <img src="@img/logo.png" class="logo" alt="">
            <span class="logo-text title_2">{{ webConfig.websiteName }}</span>
        </div>
    </div>
</template>
<script>
import webConfig from '@/config/web.config/index'
export default {
    name: 'logo',

    data() {
        return {
            webConfig: null
        }
    },
    props: {
        templalteIntro: {
            default: null
        },
        show: {
            default: true
        }
    },
    computed: {
        showBack() {
            //过滤不展示返回键的模版别名
            return this.templalteIntro ? webConfig.onboardingHiddenBackScreenNameList.includes(this.templalteIntro.screenName) : false
        }
    },
    created() {
        this.webConfig = webConfig
    },
    methods: {
        back() {

            let eventScreenJumpNumber = window.sessionStorage.getItem('eventScreenJumpNumber');
            if (eventScreenJumpNumber) {
                window.sessionStorage.removeItem('eventScreenJumpNumber');
                this.$store.commit('lastTemplate', Number(eventScreenJumpNumber))
            } else {
                this.$store.commit('lastTemplate')
            }

        }
    }
}
</script>
<style lang="scss" scoped>
.logo-box {
    padding: 10px 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: var(--bgColor);
    z-index: 99;


}

.logo-group {
    min-width: 340px;
    margin: 0 auto;
    padding: 0px 20px;
    width: 100%;
    // max-width: 768px;
    height: 44px;

    .back {
        margin-right: 10px;
        margin-left: -8px;
        color: var(--theme_01);
        font-size: 24px;
        font-weight: 700;
        cursor: pointer;
    }

    .logo {
        margin-right: var(--logoMarginRight);
        height: 24px;
    }

}

@media (max-width: 576px) {
    .logo-group {

        .logo {
            height: 24px;
        }

        .logo-text {
            font-size: 17px;
        }

    }

}
</style>